import React, {Component} from "react";
import {Col, Container, Image, Row} from "react-bootstrap";
import * as PropTypes from "prop-types";
import {gql} from "@apollo/client";


/**
 * The single value that shown in header of player profile.
 * @returns {React.ReactNode} The single value of player profile header.
 */

const InformationItem = (props) => {
    const {title, value} = props;
    return (
        <div className="information-item">
            <div className="information-item--title"> {title} </div>
            <div className="information-item--value"> {value} </div>
        </div>
    )
};


class PlayerBasicInformationCard extends Component {
    /**
     * Render the player basic information card shown in the top of page.
     * @returns {React.ReactNode} The player basic information card shown.
     */
    render = () => {
        return (
            <div className="player-basic-information-card">
                {this.renderAvatar()}
                {this.renderDetails()}
            </div>
        );
    };

    /**
     * Render avatar component shown in the left side within header.
     * @returns {React.ReactNode} The avatar component.
     */
    renderAvatar = () => {
        const {avatar} = this.props;

        return (
            <Image className="player-basic-information--avatar" roundedCircle src={avatar}/>
        );
    };

    /**
     * Render some details of player within player profile header.
     * @returns {React.ReactNode} The player details within header of player profile.
     */
    renderDetails = () => {
        const {items} = this.props;
        // const graphQLQuery = gql``;

        return (
            <div className="player-basic-information--details">
                <Container fluid={true}>
                    <Row>
                        {items?.map((item, index) =>
                            <Col xl={true} lg={2} md={3} sm={4} xs={6} className="information-item--container">
                                <PlayerBasicInformationCard.InformationItem key={index} title={item.title} value={item.value}/>
                            </Col>
                        )}
                    </Row>
                </Container>
            </div>
        )
    };

    static propTypes = {
        // The avatar that will appear in the top.
        avatar: PropTypes.object.isRequired,
    };

}

PlayerBasicInformationCard.InformationItem = InformationItem;
export default PlayerBasicInformationCard;
